import { Map } from 'immutable';
import { constants as appStorageConstants } from '@saucelabs/sl-module-app-storage';

import { AppUploadingRecord } from './records';
import * as types from './types';

const initialState = Map({
  itemsUploading: Map(),
});

const appUploadReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case types.APP_STORAGE_UPLOAD_APP.REQUEST: {
      const displayName = payload.name.trim();

      return state.setIn(
        ['itemsUploading', meta.uploadAppId],
        new AppUploadingRecord({
          id: meta.uploadAppId,
          displayName,
        }),
      );
    }
    case types.APP_STORAGE_UPLOAD_APP.PROGRESS: {
      return state.mergeIn(['itemsUploading', meta.uploadAppId], {
        progress: payload.progress,
        fileSize: payload.fileSize,
        status: appStorageConstants.APP_UPLOAD_STATUS.UPLOADING,
      });
    }
    case types.APP_STORAGE_UPLOAD_APP.PROCESSING: {
      return state.mergeIn(['itemsUploading', meta.uploadAppId], {
        progress: 100,
        status: appStorageConstants.APP_UPLOAD_STATUS.PROCESSING,
      });
    }
    case types.APP_STORAGE_UPLOAD_APP.SUCCESS: {
      return state.setIn(
        ['itemsUploading', meta.uploadAppId, 'status'],
        appStorageConstants.APP_UPLOAD_STATUS.UPLOADED,
      );
    }

    case types.APP_STORAGE_UPLOAD_APP.FAILURE: {
      return state.mergeIn(['itemsUploading', meta.uploadAppId], {
        error: 'Upload failed',
        status: appStorageConstants.APP_UPLOAD_STATUS.FAILED,
      });
    }
    // TODO: revisit if that is "possible"
    // with the current implementation canceling an upload is not possible
    case types.APP_STORAGE_UPLOAD_APP.CANCEL: {
      return state.mergeIn(['itemsUploading', meta.uploadAppId], {
        progress: 0,
        status: 'CANCELED',
      });
    }
    default:
      return state;
  }
};

export default appUploadReducer;
